export const CUSTOM_ROLE_FILTER_PREFIX = 'custom-role:';
